import React, { useState, useEffect } from "react";
import { Container, Card, CardBody, } from "reactstrap";
import CommonTableIndexWise from "Components/Common/CommonTableIndexWise";
import { useNavigate } from "react-router-dom";
import sf from "assets/scss/common/searchFilter.module.scss";
import styles from "../css/studyworkflow.module.scss";
import { useStudyDetailsService } from "hooks/useCommonQuery";
import { workflowColumns } from "../helpers/studyworkflowconstant";
import { loadCodelists } from "api/modules/common.option";
import { showToastMessage } from "common/service/CommonService";

const WorkflowDashboard: React.FC = () => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [searchFocused, setSearchFocused] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  
  useEffect(() => {
    const load = async () => {
      const result = await loadCodelists(["StudyDesign_OPTIONS"]);

      const allLoaded = Object.values(result).every((flag) => flag);
      if (!allLoaded) {
        showToastMessage("error", "Some dropdowns failed to load");
      }
    };
    load();
  }, []);

  const { SelectAllQuery } = useStudyDetailsService(
    searchText,
    null,
    undefined,
    null,
    currentPage,
    10, // Items per page
  );

  const { data: queryResponse, isLoading, isFetching } = SelectAllQuery;
  const data = queryResponse?.data ?? [];

  // Column definitions tailored for QA/QC Dashboard dynamically mapped from study response


  return (
    <Container fluid>
      <div className="mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="fw-bold mb-0 text-dark">Approvals & Reviews</h4>
        </div>
        <Card className={`mb-0 border-0 shadow-sm ${styles.dashCardContainer}`}>
          <CardBody>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <div className={`d-inline-flex align-items-center justify-content-center ${styles.dashToggleGroup}`}>
                <button className="btn btn-sm px-4 rounded-pill fw-semibold border-0 text-primary shadow-sm bg-white">
                  <i className="ri-list-check me-1" /> Pending Reviews
                </button>
                <button className="btn btn-sm px-4 rounded-pill fw-semibold border-0 text-muted bg-transparent">
                  <i className="ri-history-line me-1" /> Audit History
                </button>
              </div>

              {/* Search Bar matching VolunteerList Search Style */}
              <div className={sf.wrapper}>
                <div className={`${sf.searchBox} ${searchFocused ? sf.focused : ""}`}>
                  <i className={`ri-search-line ${sf.searchIcon}`} />
                  <input
                    type="text"
                    placeholder="Search studies..."
                    value={searchText}
                    className={sf.searchInput}
                    onChange={(e) => setSearchText(e.target.value)}
                    onFocus={() => setSearchFocused(true)}
                    onBlur={() => setSearchFocused(false)}
                  />
                  {searchText && <i className={`ri-close-line ${sf.clearIcon}`} onClick={() => setSearchText("")} />}
                </div>
              </div>
            </div>

            <CommonTableIndexWise
              columns={workflowColumns}
              data={data}
              loading={isLoading || isFetching}
              pageSize={10}
              currentPage={currentPage}
              onPageChange={(page: number) => setCurrentPage(page)}
              totalRecords={data[0]?.total_count || 0}
              showStatus={false}
              hideAction={true}
            />
          </CardBody>
        </Card>
      </div>
    </Container>
  );
};

export default WorkflowDashboard;
